import productIsChip from './productIsChip.util'

export default function extractChips (items = []) {
  return items.filter(productIsChip)
}
